import { render, staticRenderFns } from "./codeLogin.vue?vue&type=template&id=31551d6c&scoped=true&"
import script from "./codeLogin.vue?vue&type=script&lang=js&"
export * from "./codeLogin.vue?vue&type=script&lang=js&"
import style0 from "./codeLogin.vue?vue&type=style&index=0&id=31551d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31551d6c",
  null
  
)

export default component.exports